import { useHasParentMarket } from '../../../hooks/useHasParentMarket';
import { useMarketCategoriesQuery } from '../queries/useMarketCategoriesQuery';
import { useParentMarketCategoriesQuery } from '../queries/useParentMarketCategoriesQuery';

export const useMarketCategories = (marketId: number) => {
  const { hasParentMarket } = useHasParentMarket(marketId);

  const marketCategoriesQuery = useMarketCategoriesQuery(marketId, {
    enabled: hasParentMarket === false,
  });

  const parentMarketCategoriesQuery = useParentMarketCategoriesQuery(marketId, {
    enabled: hasParentMarket,
  });

  if (hasParentMarket === true) {
    return parentMarketCategoriesQuery;
  }

  return marketCategoriesQuery;
};
